<template>
    <div >
        <v-card class="card-orders-list" v-if="hasPagination">
            <v-card-title>Órdenes de pago</v-card-title>
            <v-select
                v-model="status"
                :items="statusList"
                item-value="code"
                item-text="label"
                label="Estatus"
                outlined
                @input="getOrdersList"
                class="mx-4"
            ></v-select>

            <!--   TABLE FOR PROCESSES (TABLETS AND PC)   -->
            <v-card-text class="hidden-sm-and-down">
                <v-simple-table>
                    <thead>
                    <tr>
                        <th class="primary--text">Folio Trans.</th>
                        <th class="primary--text">Estatus</th>
                        <th class="primary--text">No. Trámites</th>
                        <th class="primary--text">Fecha Creación</th>
                        <th class="primary--text">Acciones</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(order, index) in orders" :key="order.id">
                        <td>{{order.folio}}</td>
                        <td>
                            <v-chip small v-bind:color="getStatusColor(order.estatus)" text-color="white">
                                <v-icon left size="small" >
                                    {{ getStatusIcon(order.estatus) }}
                                </v-icon>
                                {{capitalizeStatus(order.estatus)}}
                            </v-chip>
                        </td>
                        <td>{{proceduresCounter[index]}}</td>
                        <td>{{order.created_at}}</td>
                        <td>
                            <v-btn
                                tile small
                                color="primary" class="mr-2"
                                @click="goToEditOrder(order.id)"
                            >
                                <v-icon left>fas fa-plus</v-icon>Detalles
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>

            <!--   LIST FOR ORDER (MOBILE)   -->
            <v-list three-line class="pt-0 hidden-md-and-up">
                <template v-for="(order, index) in orders">
                    <v-divider class="mx-4" :key="'o'+index" v-if="index > 0"></v-divider>

                    <v-list-item @click="function (){}" :key="'mp'+index">

                        <v-list-item-avatar v-bind:color="getStatusColor(order.estatus)">
                            <v-icon color="white">{{ getStatusIcon(order.estatus) }}</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title class="primary--text">
                                {{'Folio '+order.folio +' ('+proceduresCounter[index] + (proceduresCounter[index] === 1 ? ' trámite)':' trámites)')}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{ capitalizeStatus(order.estatus) +' - Creado el '+ order.created_at }}
                            </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-btn icon @click="goToEditOrder(order.id)">
                                <v-icon color="primary">mdi-send</v-icon>
                            </v-btn>
                        </v-list-item-action>

                    </v-list-item>
                </template>
            </v-list>
            <!--   ENDS LIST FOR ORDER (MOBILE)   -->

        </v-card>
        <div class="text-center pa-2 pb-4">
            <v-pagination
                color="main_color"
                v-if="hasPagination" v-model="page"
                :length="paginator ? paginator.total_pages : 0"
                total-visible="10"
                @input="getOrdersList"
            ></v-pagination>
        </div>

    </div>
    <!-- END TABLE FOR PROCESSES   -->
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import {ordersRequestModel} from "../../api/models";
import {getOrderStatusColor, getOrderStatusIcon} from "../../core/assets_utils";
import {capitalizeWord} from "../../core/utils";

export default {
    name: "List",

    computed: {
        ...mapState({ordersStore: state => state.orders}),
        ...mapGetters('orders', ['hasPagination', 'orders', 'paginator', 'proceduresCounter'])
    },

    data() {
        return {
            page: 1,
            pageLimit: 10,
            status: 'todo',
            statusList: [
                {label: 'Todos', code: 'todo'}, {label: 'Pendiente', code: 'pendiente'},
                {label: 'Pagado', code: 'pagado'}, {label: 'Declinado', code: 'declinado'},
                {label: 'Referenciado', code: 'referenciado'}, {label: 'Cancelado', code: 'cancelado'},
                {label: 'Vencido', code: 'vencido'}
            ]
        }
    },

    mounted() {
        this.getOrdersList()
    },

    methods: {
        ...mapActions('orders', ['getOrders']),

        getOrdersList (){
            let ordersRequest = ordersRequestModel()
            ordersRequest.data.page = this.page
            ordersRequest.data.limit = this.pageLimit
            ordersRequest.data.status = this.status
            ordersRequest.data = JSON.stringify(ordersRequest.data)

            //Call to VueX orders.module -> getOrders
            this.getOrders(ordersRequest)
        },

        getStatusColor(status){
            return getOrderStatusColor(status)
        },

        getStatusIcon(status){
            return  getOrderStatusIcon(status)
        },

        capitalizeStatus(status){
            return capitalizeWord(status)
        },

        goToEditOrder(orderId){
            this.$router.push({name: 'orders_details', params: {action: 'edit', id: orderId}})
        }
    }
}
</script>

<style scoped>
.theme--light.v-pagination .v-pagination__navigation {
    background: rgba(0,0,0,0)!important;
    box-shadow: none !important;
}

</style>